import React               from 'react';
import * as moment         from 'moment';
import useHeadingQuestion  from '../../Records/useSurvey/useHeadingQuestion';
import { KirokuInputIcon } from '../../../ui';

export default function TimeQuestion(props) {

    const { question, value = null } = props;

    const { heading, t } = useHeadingQuestion(question);

    return (<div className={'content-question-type'}>
        <div className='wraper-question none-border-question pt-2 pt-2'>
            <div className="background-question">
                {heading && <div className="text-overflow-elip font-heading-questions pb-10px">{ heading }</div> }
                <div className='padding-content-question'>
                    <span className={'font-content-question'}>
                        {question.unrequited ? t('createRecord.option'):''}{question.content}
                    </span>
                </div>
            </div>
            <div className='answer-question padding-16-answer-question'>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <KirokuInputIcon readOnly name={'time'} icon={'far fa-clock'}
                                         style={{color: '#0a1d42', height: "35px", paddingLeft: '2rem'}}
                                         value={value ? moment.unix(value).format(t('dateTimeFormat.HourMinute')) : ''}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>);
}
